const metric = {
  distance: 'meter',
  distance_cgs: 'cm',
  temperature: '°C',
  temperatureWithDegreeSuffix: 'C°',
};
export default metric;
